module.exports = __webpack_public_path__ + "static/media/intro.aa92459f.wav";